import analysisModule from "../analysisModule"
import server from "../../server"

analysisModule.service("nodeCommandOpenDeliveryOverviewMonitoring", [
    "$http",
    "$state",
    "remoteExceptionHandler",
    "loadingService",
    function ($http, $state, remoteExceptionHandler, loadingService) {
        return function (selection) {
            return loadingService($http.post(server.getServiceUrl("findMonitorableSourceIdByNodeIdentifier"), selection)
                .then(function (response) {
                    let url = $state.href("monitoring.deliveryOverview", {sourceId: response.data})
                    window.open(url, "_blank")
                }))
                .catch(remoteExceptionHandler())
        }
    }])